import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { useRouteLoaderData } from '@remix-run/react';

import PrivatePublication from '~/pages/index/PrivatePublication';

import StaticPage from '~/components/StaticPage';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';

import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import type { StaticPageLoaderData } from '../services/static_page';
import { staticPageLoader } from '../services/static_page';

import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import type { RootLoaderData } from '~/root';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request }) => {
  return staticPageLoader({
    request,
  });
};

export const clientLoader = staticPageClientLoader;

// TODO: Comment Back in when this is ready to go live. This was tested safely and don't want to lose this code.
// export const clientLoader = async ({ request, params, serverLoader }: ClientLoaderFunctionArgs) => {
//   const serverData = await serverLoader<StaticPageLoaderData>();
//   const postIds = collectPagePostIds({ page: serverData?.page });
//   const testRes = await fetch(`/posts_insights_v2?post_ids=${postIds}`);
//   const postInsights = await testRes.json();

//   return {
//     ...serverData,
//     postInsights,
//   };
// };

// clientLoader.hydrate = true;

const Home = () => {
  const { page, site } = useTypedLoaderData<StaticPageLoaderData>();
  const { isLoggedIn, isStagingPreview } = useRouteLoaderData('root') as RootLoaderData;

  if ((site.publication.private || site.publication.require_subscriber_approval) && !isLoggedIn && !isStagingPreview) {
    return <PrivatePublication publication={site.publication} />;
  }

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Home;
